<template>
<legal-document title="Пользовательское соглашение" type="eula" />
</template>

<script>
import LegalDocument from './../../components/legal/LegalDocument';
import InjectsSeo from "@/mixins/InjectsSeo";

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return {
      title: this.getFullPageTitle('Пользовательское соглашение'),
    }
  },

  components: {
    LegalDocument,
  },
}
</script>
